import ClientLayout from "../../../components/client/layout/ClientLayout";
import {useParams} from "react-router-dom";
import ClientProjectRequest from "../../../components/client/project/ClientProjectRequest";

//클라이언트 프로젝트 추가 요청 상세 페이지
const ClientProjectRequestInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //요청 식별자가 없는 경우
    if (!id) {
        return <div>Invalid project ID</div>;
    }

    return (
        <ClientLayout>
            {/*프로젝트 추가 요청 상세 페이지 버튼*/}
            <ClientProjectRequest projectRequestId={parseInt(id)}/>
        </ClientLayout>
    );
};

export default ClientProjectRequestInfoPage;